import React, { useEffect, useState } from "react";
import FilterSelector from "../Components/FilterSelector";
import LinearGauge from "../Components/LinearGauge";
import { AgCharts } from "ag-charts-react";
import { baseColors } from "../../../../utils/handlers";

function IncomeConsistencyIndex({ data }) {
  const [activeDuration, setActiveDuration] = useState("overall_summary");
  const [incomeValue, setIncomeValue] = useState(0);
  const [incomeStatus, setIncomeStatus] = useState("");
  function formatToIndianRupees(num) {
    // Convert the number to a string
    if (num === null || num === undefined) return "₹--";
    return num.toLocaleString("en-IN", {
      maximumFractionDigits: 0,
      style: "currency",
      currency: "INR",
    });
  }

  const [barGraph, setBarGraph] = useState([]);
  const [series, setSeries] = useState([]);
  const [options, setOptions] = useState({
    data: barGraph,
    series: series,
    legend: {
      item: {
        label: {
          fontSize: 11, // Change the legend font size

          fontWeight: "normal",
          color: "#637381", // Change the legend font color
        },
        marker: {
          size: 11, // Change the size of the color boxes
        },
      },
    },

    axes: [
      {
        type: "category",
        position: "bottom",
        gridLine: false,
        label: {
          fontSize: 9,
          fontWeight: "light",
        },
      },
      {
        type: "number",
        position: "left",
        label: {
          fontWeight: "normal",
          fontSize: 11,
          formatter: (params) => {
            // Format with thousand separators and add a currency symbol
            return `${formatToIndianRupees(params.value)}`;
          },
        },
        gridLine: false,
      },
    ],
    barPadding: 0.1, // Default is 0.1, lower this value to reduce bar width
    groupPadding: 0.1,
    height: 340,
  });

  const mapDataBarGraph = (data) => {
    const array = Object.keys(data).map((key) => {
      const quarter = key;
      const main = data[key];
      const subObject = Object.keys(main).reduce((acc, subkey) => {
        acc[subkey] = main[subkey]; // Set the value to the second element
        return acc;
      }, {});
      return {
        quarter: quarter,
        ...subObject,
      };
    });

    return array;
  };
  const mapSeries = (data) => {
    const array = data.map((item, index) => {
      return {
        type: "bar",
        xKey: "quarter",
        yKey: item,
        yName: item,
        cornerRadius: 10,
        fill: baseColors[index % baseColors.length],
        stacked: true,
      };
    });

    return array;
  };
  const getColor = (remark) => {
    switch (remark) {
      case "Critical":
      case "Low":
        return "#d30d00";
      case "Medium":
        return "#f7a452";
      case "High":
        return "#00960f";
      default:
        return "#d6d6d6";
    }
  };
  useEffect(() => {
    setBarGraph(
      mapDataBarGraph(
        data
          ? data[activeDuration]?.income_consistency_index?.income_categories
          : []
      )
    );
    setSeries(
      mapSeries(
        data ? data[activeDuration]?.income_consistency_index?.legend_array : []
      )
    );

    setIncomeValue(
      data
        ? data[activeDuration]?.income_consistency_index?.consistency_ratio
        : 0
    );
    setIncomeStatus(
      data
        ? data[activeDuration]?.income_consistency_index?.consistency_status
        : ""
    );
  }, [activeDuration, data]);
  useEffect(() => {
    setOptions({ ...options, data: barGraph, series: series });
  }, [barGraph, series]);

  return (
    <div className=" w-[49.5%] border border-[#e6ebed] rounded-lg ">
      <div className=" rounded-t-lg bg-[#f3f3f3] py-3 px-4 text-[#212b36] font-bold">
        <p>Income Consistency Index</p>
      </div>
      <FilterSelector
        activeDuration={activeDuration}
        setActiveDuration={setActiveDuration}
      />
      <div className=" mt-6 mb-6 flex flex-col items-center">
        <p className=" text-center text-[32px] font-bold">{incomeValue}</p>
        <LinearGauge
          value={incomeValue}
          color={getColor(incomeStatus)}
          partial={true}
          remark={incomeStatus}
        />
        <p className=" text-xs font-medium text-[#262626] mt-4">
          Income Consistency Index is{" "}
          <span
            style={{
              color: getColor(incomeStatus),
            }}
            className={` font-bold t`}
          >
            {incomeStatus}
          </span>{" "}
        </p>
      </div>
      <div className=" overflow-x-auto mt-[56px] overflow-y-hidden ">
        <p className="text-[#212b36] text-xs font-bold ml-[15.75px]">
          Income Categorization
        </p>
        <div className="mt-1 ">
          <AgCharts options={options} />{" "}
        </div>
      </div>
    </div>
  );
}

export default IncomeConsistencyIndex;
